import axios from 'axios';

const instance = axios.create({
  baseURL: `/wp-json/amante-booking/v1/`,
  timeout: 100 * 1000,
});

export default instance;
